import application_settings from '../applicationSettings';
import Event from './Event';
import LocalStorage from '../local_data';

class GetShippingPrimaryPrice extends Event {
    eventName = 'oms_getShippingPrimaryPrice';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get shipping primary price for given client id
     * 
     * @param {string} data.location_id -  location id 
     * @param {string} data.customer_id -  customer id 
     * @param {string} data.address_info -  address info 
     * @param {string} data.products -  products
     * @param {string} data.flash_delivery -  flash delivery
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        let currentLocation = new LocalStorage.CurrentLocation(clientId).getData();
        let selectedProducts = new LocalStorage.CartLocation(currentLocation).getData();
        let userData = new LocalStorage.UserData(currentLocation).getData();
        let products = [];

        if (selectedProducts && Object.keys(selectedProducts).length > 0) {
            Object.keys(selectedProducts).forEach(function (item) {
                products.push({
                    "id": item,
                    "count": selectedProducts[item].item_qty
                });
            });
        }

        let address_info = data.address_info;
        if (address_info) {
            address_info.location_id = currentLocation;
        }
    
        // request data
        data.endPoint = application_settings.endPoints.shippingPrimaryPrice;
        data.method = 'POST';
        data.data = {
            client_id: clientId,
            location_id: currentLocation,
            customer_id: (userData) ? userData.id : null,
            address_info: JSON.stringify(address_info),
            products: JSON.stringify(products),
            flash_delivery: data.flash_delivery,
            order_currency: data.order_currency,
        };
    
        this.sendRequest(data, function (response) {
            if (response) {
                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
            }
        });
    }
}

export default GetShippingPrimaryPrice;